import React, { useContext } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import { NetaSetting } from 'constants/neta-settings';
import { NetaSettingContext } from 'providers/netaSettingsProvider';
interface IlliquidInvestmentModalProps {
    open: boolean;
    close: () => void;
}
export const IlliquidInvestmentModal: React.FC<IlliquidInvestmentModalProps> = ({
    open, close
}) => {
    const NETA = useContext<NetaSetting>(NetaSettingContext);
    return (
        <Dialog open={open} onClose={close}>

            <>
                <DialogTitle sx={{ my: 2 }}>
                    {" "}
                    <Typography sx={{ color: "neutral" }} variant="subtitle1">
                        Non-Liquid Asset
                    </Typography>{" "}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="bodyCopyRegular" gutterBottom>
                        This asset is currently marked as not being liquid. Please  <Link target="_blank" href={`mailto:${NETA.supportEmail}`} underline="always" color={'inherit'} sx={{
                            "&:hover": {
                                cursor: "pointer",
                            }
                        }}> email us</Link> or call us at {NETA.phoneNumber} to discuss how to sell it.

                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 4 }}>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => close()}
                        >
                            Got it
                        </Button>
                    </Box>
                </DialogContent>
            </>

        </Dialog>


    )
}
